import Color from './Color.vue'
import Emoji from './Emoji.vue'
import Item from './Item.vue'
import Link from './Link.vue'

export default {
  Color,
  Emoji,
  Item,
  Link,
}
